export default {
    translation: {
        title: "Amerika",
        applications: "Anwendungen",
        full_text: "Vollständiger Text",
        vehicle: {
            status: "Fahre nach {{direction}} mit {{speed}} mph."
        },
        talkie: {
            drivers_nearby_singular: "1 Fahrer in der Nähe",
            drivers_nearby_plural: "{{count}} Fahrer in der Nähe"
        },
        settings: {
            save_progress_description:
                "Speichere deinen Fortschritt auf einer Diskette zur Sicherung oder zum Übertragen zwischen Computern.",
            save_progress_action: "Fortschritt speichern",
            load_progress_action: "Fortschritt laden...",
            display_units: "Anzeigeeinheiten",
            imperial: "Imperial",
            metric: "Metrisch",
            start_over_description:
                "Beende deine Reise vorzeitig. Der aktuelle Fortschritt wird gelöscht. Dies kann nicht rückgängig gemacht werden.",
            start_over_action: "Neu starten"
        },
        feedback: {
            message: "Nachricht",
            contact_info: "Kontaktinformationen (optional)",
            send: "Senden",
            sending: "Wird gesendet..."
        },
        radio: {
            no_reception: "kein Radioempfang in diesem Bereich",
            low_signal: "schwaches Signal",
            turn_off: "Ausschalten",
            turn_on: "Einschalten",
            next_station: "Nächster Sender",
            unmute: "Stimme aktivieren",
            mute: "Stummschalten"
        },
        photos: {
            source: "Von Mapillary",
            empty: "Ich schaue mich um, um ein Foto zu machen..."
        },
        news: {
            loading: "Ich durchsuche die lokalen Schlagzeilen...",
            nothing_found: "Nichts gefunden."
        },
        metrics: {
            duration_title: "Fahrzeit",
            duration_value: "{{days}}T {{hours}}Std {{minutes}}Min",
            distance_title: "Zurückgelegte Strecke",
            emissions_title: "CO2-Ausstoß",
            emissions_value_g: "{{g}} g",
            emissions_value_kg: "{{kg}} kg",
            states_visited_title: "Besuchte Bundesstaaten",
            cairns_discovered_title: "Gefundene Cairns",
            exploration_title: "Erforschung"
        },
        compass: {
            north_east: "Nordost",
            east: "Ost",
            south_east: "Südost",
            south: "Süd",
            south_west: "Südwest",
            west: "West",
            north_west: "Nordwest",
            north: "Nord"
        },
        landing: {
            about_title: "Über",
            start_title: "Starten",
            features_title: "Funktionen",
            about_headline: "America: Roadtrip-Simulator in deinem Browser",
            about_paragraph_1:
                "Safari, Chrome, Edge. Das sind Tore zu den unendlichen Ecken des Webs.\n"
                + "America ist dein Tor zu einer anderen Art von weitläufigem Gelände: die\n"
                + "Naturwunder der Vereinigten Staaten, wo es genauso viel zu lernen gibt, in\n"
                + "deinem eigenen Tempo.",
            about_paragraph_2:
                "Von monumentalen Landschaften bis zu ruhigen Momenten am Straßenrand steuerst\n"
                + "du die Reise durch eine Desktop-ähnliche Fensteroberfläche: Karte, Live-Radio,\n"
                + "Enzyklopädieartikel, Fotogalerie, Statistiken, Tagebuch und mehr. Kein\n"
                + "Punktestand, kein Zeitdruck: Zufall und Atmosphäre zuerst. Öffne es in einem\n"
                + "modernen Browser; nichts zu installieren.",
            about_paragraph_3:
            "Deine Reise kann der Pacific Coast Highway entlangführen, der Route 66 durch"
                + "die Ebenen folgen, durch die Rockies zu Nationalparks winden oder über"
                + "Nebenstraßen Neuenglands führen. Jeder Halt zeigt die lokale Geschichte: was"
                + "dieser Ort, Canyon oder Aussichtspunkt gesehen hat, was im Radio läuft und wie"
                + "das Wetter gerade ist. Ein Roadtrip-Simulator, um die USA in deinem Tempo zu"
                + "erkunden, im Browser, auf jedem Gerät.",

            trips_title: "Nach Reise erkunden",
            trips_list: [
                { label: "Virtueller Roadtrip", url: "/virtual-road-trip/" },
                { label: "USA-Roadtrip", url: "/us-road-trip/" },
                { label: "Roadtrip durch Nationalparks", url: "/national-parks-road-trip/" },
                { label: "Route-66-Roadtrip", url: "/route-66-road-trip/" },
                { label: "Amerika entdecken", url: "/explore-america/" },
                { label: "Roadtrip quer durch Amerika", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "Werbung ansehen",
            start_cta: "Reise starten",
            start_cta_lead: "Keine Installation. Läuft in deinem Browser.",
            features_lede:
                "Sobald deine Reise beginnt, richtest du das Dashboard aus Americas\n"
                + "Roadtrip-Suite ein. Jedes Fenster ist eine andere Art, das Land zu erleben. Vom\n"
                + "lokalen Radio bis zum Walkie-Talkie mit anderen Fahrern wirst du bei jeder\n"
                + "Reise etwas Neues entdecken.",
            features_list: [
                "Karte mit Routenplanung und Erkundung in den gesamten USA",
                "Streaming-Radio und ortgebundene Artikel & Fotos",
                "Tagebuch, Statistiken, Fotogalerie und Enzyklopädie",
                "Freunde, Sprachchat und geteilte Wegmarken (Cairns)",
                "Läuft im Browser auf Handy oder Desktop; ohne Download",
            ],
            media_alt: "America Complete Edition: Software-Box und CD",
            slideshow_alt: "Landschaftsfotografie aus dem America Roadtrip-Simulator, Bild",
            og_title: "America: Roadtrip-Simulator",
            og_description:
                "Entdecke die Naturwunder der Vereinigten Staaten in einem verspielten Roadtrip-Simulator im Desktop-Stil. Karten, Radio, Tagebuch und zufällige Entdeckungen, direkt in deinem Browser.",
            twitter_description:
                "Entdecke die Naturwunder der Vereinigten Staaten in einem verspielten Roadtrip-Simulator im Desktop-Stil. Keine Installation.",
            meta_description:
                "Fahre über echte US-Highways und entdecke Naturwunder in einem kostenlosen Roadtrip-Simulator im Browser. Karten, Radio, Fotos. Kein Download.",
            jsonld_description:
                "America ist ein Roadtrip-Simulator in deinem Browser: erkunde die Naturwunder der USA in deinem eigenen Tempo mit Karten, Radio, Fotos und einer Desktop-ähnlichen Oberfläche. Kein Download erforderlich; starte deine Reise online.",
            jsonld_genre: ["Roadtrip-Simulator", "Entdeckungsspiel", "Browserspiel"],
            page_title: "USA-Roadtrip-Simulator | America",
            html_lang: "de",
            og_locale: "de_DE",
            og_locale_alternate: ["en_US", "es_ES", "fr_FR", "ru_RU", "ja_JP", "ko_KR", "zh_CN", "pt_BR"],
            og_image_alt: "Screeshot des Roadtrip-Simulators America",
            twitter_image_alt: "Screeshot des Roadtrip-Simulators America",
        },
    }
};
